export default [
    {
        path: '/dictionary',
        name: '/Dictionary',
        component: () => import('@/views/Dictionary/DictionaryHome/DictionaryHome.vue'),
        meta: { code: 'dictionary' }
    },
    {
        path: '/dictionary-read',
        name: '/DictionaryRead',
        component: () => import('@/views/Dictionary/DictionaryRead/DictionaryRead.vue'),
        meta: { code: 'dictionaryRead' }
    },
]